import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faCreditCard, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import DashboardHeader from '../components/Other/DashboardHeader';
import PageHeader from '../components/PageHeader';

const StripeConnect = () => {
  const [isConnected, setIsConnected] = useState(true); // Set to true as mentioned in the menu item

  const handleDisconnect = () => {
    // Here you would typically call an API to disconnect from Stripe
    // For now, we'll just update the state
    setIsConnected(false);
  };

  const handleConnect = () => {
    // Here you would typically redirect to Stripe Connect OAuth flow
    // For now, we'll just update the state
    setIsConnected(true);
  };

  return (
    <>
      <DashboardHeader />
      <div className="flex justify-center items-start min-h-screen bg-[#e32f2f] text-gray-800">
        <div className="w-full max-w-md px-4 py-6 space-y-4">
          {/* Header with back button */}
          <PageHeader title="Stripe Connect" />
          
          {/* Stripe Connect content */}
          <div className="bg-gray-100 rounded-xl p-4">
            <div className="mb-4">
              <div className="flex items-center mb-4">
                <FontAwesomeIcon icon={faCreditCard} className="text-purple-600 text-xl mr-2" />
                <h2 className="font-semibold">Stripe Payment Processing</h2>
              </div>
              
              {isConnected ? (
                <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
                  <div className="flex items-center">
                    <FontAwesomeIcon icon={faCheckCircle} className="text-green-500 mr-2" />
                    <span className="font-medium text-green-700">Your Stripe account is connected</span>
                  </div>
                  <p className="text-sm text-gray-600 mt-2">
                    You can receive payments for your products and services.
                  </p>
                  
                  <div className="mt-4">
                    <h3 className="font-medium mb-2">Account Details</h3>
                    <div className="text-sm">
                      <p><span className="font-medium">Account ID:</span> acct_1234567890</p>
                      <p><span className="font-medium">Status:</span> Active</p>
                      <p><span className="font-medium">Connected Since:</span> January 15, 2023</p>
                    </div>
                  </div>
                  
                  <div className="mt-4 flex justify-between">
                    <a 
                      href="https://dashboard.stripe.com" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-purple-600 hover:text-purple-800 flex items-center"
                    >
                      <span>Go to Stripe Dashboard</span>
                      <FontAwesomeIcon icon={faExternalLinkAlt} className="ml-1 text-xs" />
                    </a>
                    
                    <button 
                      onClick={handleDisconnect}
                      className="text-red-600 hover:text-red-800"
                    >
                      Disconnect
                    </button>
                  </div>
                </div>
              ) : (
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-4">
                  <p className="text-sm text-gray-600 mb-4">
                    Connect your Stripe account to receive payments for your products and services.
                  </p>
                  
                  <button 
                    onClick={handleConnect}
                    className="bg-purple-600 hover:bg-[#6d29f6] text-white font-medium py-2 px-4 rounded-lg w-full flex items-center justify-center"
                  >
                    <FontAwesomeIcon icon={faCreditCard} className="mr-2" />
                    Connect with Stripe
                  </button>
                </div>
              )}
              
              <div className="text-sm text-gray-500 mt-4">
                <h3 className="font-medium mb-2">About Stripe Connect</h3>
                <p className="mb-2">
                  Stripe Connect allows you to receive payments directly to your bank account.
                  Our platform uses Stripe to handle all payment processing securely.
                </p>
                <p>
                  By connecting your Stripe account, you agree to Stripe's 
                  <a href="https://stripe.com/terms" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-700"> Terms of Service</a>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StripeConnect;